<template>
    <v-dialog
        v-if="updateObj"
        v-model="show"
        width="50%"
        outline
    >
        <v-card>
            <v-card-title class="text-h5 py-3">Call Type</v-card-title>
            <v-layout>
                <v-flex xs6>
                    <v-card-text class="py-0">
                        <v-text-field
                            data-testid="current-call-type-input"
                            class="current-call-type-input"
                            label="Current call type..."
                            v-model="callTypeName"
                            filled
                            readonly
                        />
                    </v-card-text>
                </v-flex>
                <v-flex class="mt-2 pt-2">
                    <v-icon>arrow_forward</v-icon>
                </v-flex>
                <v-flex xs6>
                    <v-card-text class="py-0">
                        <v-select
                              data-testid="update-call-type-menu"
                              class="update-call-type-menu"
                              v-if="callTypes"
                              label="Select new call type..."
                              :items="callTypes"
                              v-model="newCallType"
                              item-text="name"
                              item-value="id"
                              filled
                              required
                              request-object
                        />
                    </v-card-text>
                </v-flex>
            </v-layout>
            <v-card-title class="text-h5 py-0">Disposition Type</v-card-title>
            <v-layout>
                <v-flex xs6>
                    <v-card-text>
                        <v-text-field
                            data-testid="current-disposition-type-input"
                            class="current-disposition-type-input"
                            label="Current disposition type..."
                            v-model="updateObjName"
                            filled
                            readonly
                        />
                    </v-card-text>
                </v-flex>
                <v-flex class="mt-4 pt-2">
                    <v-icon>arrow_forward</v-icon>
                </v-flex>
                <v-flex xs6>
                    <v-card-text>
                        <v-select
                          data-testid="update-disposition-type-menu"
                          class="update-disposition-type-menu"
                          label="Select new disposition type..."
                          :items="filteredDisposition"
                          :disabled="!newCallType"
                          v-model="newDisposition"
                          item-text="name"
                          item-value="id"
                          filled
                          return-object
                          required
                        />
                    </v-card-text>
                </v-flex>
            </v-layout>
            <v-form ref="form">
                <v-divider />
                <v-card-actions>
                    <v-btn
                        data-testid="cancel-update-disposition-btn"
                        class="cancel-update-disposition-btn"
                        color="error"
                        @click="cancel"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        data-testid="submit-update-disposition-btn"
                        class="submit-update-disposition-btn"
                        color="primary"
                        @click="triggerUpdate"
                        :disabled="!validInfo"
                    >
                        Update
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
  props: {
    callTypes: {
      type: Array
    },
    dispositionTypes: {
      type: Array
    },
    updateObj: {
      type: Object
    },
    value: {
      type: Boolean
    }
  },

  data() {
    return {
      newCallType: null,
      newDisposition: null
    };
  },

  methods: {
    cancel() {
      this.show = false;
      this.newCallType = null;
      this.newDisposition = null;
    },

    triggerUpdate() {
      this.$emit("updateDispositionAndCall", this.newDisposition);
      this.newCallType = null;
      this.newDisposition = null;
    }
  },

  computed: {
    callTypeName() {
      if (
        !this.updateObj ||
        !this.updateObj.disposition ||
        !this.updateObj.disposition.call_type
      ) {
        return " – ";
      }
      return this.updateObj.disposition.call_type.name;
    },
    show: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },

    validInfo() {
      return this.newCallType && this.newDisposition;
    },

    updateObjName() {
      return (this.updateObj && this.updateObj.disposition)
        ? this.updateObj.disposition.name
        : "";
    },

    filterDispositions() {
      return this.newCallType ? this.callTypes.filter(id => id.id === this.newCallType) : "";
    },

    filteredDisposition() {
      return this.filterDispositions ? this.filterDispositions[0].dispositions : [];
    }
  }
};
</script>

<style scoped>

</style>
